import { Spinner } from "@void-orbit/ui";

export interface SpinLoadingProps {
  show: boolean;
};

export const SpinLoading = ({ show }: SpinLoadingProps ) => show ? <Spinner /> : null;
